<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(exportReport)">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose Date Range</p>
          </header>
          <section class="modal-card-body">
            <BaseDatePicker
              v-model="criteria.start_time"
              label="Start Date"
              :rules="'required'"
            >
            </BaseDatePicker>
            <BaseDatePicker
              v-model="criteria.end_time"
              label="End Date"
              :rules="'required'"
              :min-datetime="criteria.start_time"
            >
            </BaseDatePicker>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              :loading="loading"
              @click.prevent="passes(exportReport)"
            >
              Export
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker'
import ScheduleApi from '@/api/schedules'

export default {
  name: 'ExportScheduleModal',
  components: {
    BaseDatePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    reportType: {
      type: String,
      default: '',
    },
    channelId: {
      type: Number,
      default: null,
    },
    start: {
      type: Date,
      default: null,
    },
    end: {
      type: Date,
      default: null,
    },
    channelName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      criteria: {
        start_time: this.start || new Date(),
        end_time: this.end || new Date(),
      },
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    },
  },
  async created() {
    this.initialized = true
  },
  methods: {
    async exportReport() {
      try {
        this.loading = false
        switch (this.reportType) {
          case 'epg':
            await ScheduleApi.exportEpg(
              this.channelId,
              this.criteria.start_time,
              this.criteria.end_time,
              this.channelName
            )
            break
          case 'nielsen':
            await ScheduleApi.exportNielsen(
              this.channelId,
              this.criteria.start_time,
              this.criteria.end_time,
              this.channelName
            )
            break
          case 'production':
            await ScheduleApi.exportProduction(
              this.channelId,
              this.criteria.start_time,
              this.criteria.end_time,
              this.channelName
            )
            break
          case 'break':
            await ScheduleApi.exportBreak(
              this.channelId,
              this.criteria.start_time,
              this.criteria.end_time,
              this.channelName
            )
            break
        }
        this.closeModal()
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Error exporting schedule',
          position: 'is-top',
          type: 'is-danger',
        })
        this.loading = false
      }
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
